import React from 'react'

function Image () {
  return (
    <div className='profile__title--image'>
      <img src='https://res.cloudinary.com/oddert/image/upload/v1581962527/Portfolio/folio_profile.jpg' alt='robyn veitch' />
    </div>
  )
}

export default Image
